import { DataItem, StatusContainer } from '@servicetitan/financing-utils-shared';
import DeclinedIllustration from '../../common/illustrations/unable-to-load.svg';
import { Card, Text } from '@servicetitan/anvil2';
import { ApplicationDataStore } from '@servicetitan/financing-application-shared';
import { useSecondLookProviderName } from '@servicetitan/financing-workflow-shared';
import { SecondLookFinancingOption } from './SecondLookFinancingOption';
import { DecisionDataStore } from '../stores/DecisionDataStore';

const formatDate = (date: Date) => {
    return date.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
    });
};

export const Declined = () => {
    const { applicationData } = ApplicationDataStore.useStore();
    const { decisionData } = DecisionDataStore.useStore();
    const secondLookProviderName = useSecondLookProviderName();

    return (
        <StatusContainer
            image={DeclinedIllustration}
            headline={`${secondLookProviderName} was not able to approve your application`}
            message={
                decisionData?.declineRedirectUrl
                    ? 'Thanks for your patience while we continue the search. We may need additional information to qualify you for your best financing options. Please select "Explore Options" below.'
                    : undefined
            }
        >
            <Card flexDirection="column" gap="2" style={{ width: '100%' }}>
                <Text variant="body" style={{ fontWeight: 'bold' }}>
                    Application Summary
                </Text>
                <DataItem
                    label="Applicant Name"
                    text={`${applicationData.applicant.primaryApplicant?.firstName} ${applicationData.applicant.primaryApplicant?.lastName}`}
                />
                <DataItem label="Date" text={formatDate(new Date())} />
            </Card>
            <SecondLookFinancingOption />
        </StatusContainer>
    );
};
